import type { CreateWithdrawalRequest } from "@repo/shared/types";
import { del, get, patch, post } from "../_client";

const BASE = "/internal/flow-instances";

export type WithdrawalItem = {
  id: string;
  name: string;
  scheduleType: "one_time" | "recurring";
  oneTimeAmount: number | null;
  oneTimeDate: string | null;
  recurringAmount: number | null;
  recurringFrequency: "monthly" | "quarterly" | "yearly" | null;
  recurringStartDate: string | null;
  recurringEndDate: string | null;
  order: number;
};

export type WithdrawalFormData = {
  name: string;
  scheduleType: "one_time" | "recurring";
  oneTimeAmount?: number | null;
  oneTimeDate?: string | null;
  recurringAmount?: number | null;
  recurringFrequency?: "monthly" | "quarterly" | "yearly" | null;
  recurringStartDate?: string | null;
  recurringEndDate?: string | null;
};

type MutationResponse = {
  success: boolean;
  error?: string;
  data?: WithdrawalItem;
};

export function listWithdrawals(instanceId: string) {
  return get<WithdrawalItem[]>(`${BASE}/${instanceId}/withdrawals`);
}

export function createWithdrawal(instanceId: string, data: WithdrawalFormData) {
  return post<MutationResponse>(
    `${BASE}/${instanceId}/withdrawals`,
    data satisfies CreateWithdrawalRequest,
  );
}

export function updateWithdrawal(withdrawalId: string, data: WithdrawalFormData) {
  return patch<MutationResponse>(
    `${BASE}/withdrawals/${withdrawalId}`,
    data satisfies CreateWithdrawalRequest,
  );
}

export function deleteWithdrawal(withdrawalId: string) {
  return del<{ success: boolean; error?: string }>(`${BASE}/withdrawals/${withdrawalId}`);
}
